import { render, staticRenderFns } from "./SubscriptionEdit.vue?vue&type=template&id=afd96e1c"
import script from "./SubscriptionEdit.vue?vue&type=script&lang=js"
export * from "./SubscriptionEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports